module.exports = __webpack_public_path__ + "img/event-square-2.5847fc84.jpg";